import Model from '@/models/Model'

export default class HrIsapreType extends Model {
    resource() {
        return 'hr_isapre_type'
    }
}